"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ON_ACTION_THROTTLE_MS = exports.SERVER_CALL_INTERVAL_MS = void 0;
exports.SERVER_CALL_INTERVAL_MS = 1000 * 60 * 30;
exports.ON_ACTION_THROTTLE_MS = 5000;
